"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILimitation = void 0;
var ILimitation;
(function (ILimitation) {
    ILimitation["LowImpact"] = "Low Impact";
    ILimitation["PregnancyFriendly"] = "Pregnancy-friendly";
    ILimitation["FloorWork"] = "Floor work";
})(ILimitation || (exports.ILimitation = ILimitation = {}));
//# sourceMappingURL=limitation.js.map